// This file was generated by "make codegen/iam". DO NOT EDIT.

import { CREATE_GROUP as ACTION_MONDOO_SCIM_USERPROVISIONING_CREATEGROUP } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/CreateGroup/action";
import { CREATE_USER as ACTION_MONDOO_SCIM_USERPROVISIONING_CREATEUSER } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/CreateUser/action";
import { DELETE_GROUP as ACTION_MONDOO_SCIM_USERPROVISIONING_DELETEGROUP } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/DeleteGroup/action";
import { DELETE_USER as ACTION_MONDOO_SCIM_USERPROVISIONING_DELETEUSER } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/DeleteUser/action";
import { GET_GROUP as ACTION_MONDOO_SCIM_USERPROVISIONING_GETGROUP } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/GetGroup/action";
import { GET_USER as ACTION_MONDOO_SCIM_USERPROVISIONING_GETUSER } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/GetUser/action";
import { LIST_GROUPS as ACTION_MONDOO_SCIM_USERPROVISIONING_LISTGROUPS } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/ListGroups/action";
import { LIST_USERS as ACTION_MONDOO_SCIM_USERPROVISIONING_LISTUSERS } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/ListUsers/action";
import { UPDATE_GROUP as ACTION_MONDOO_SCIM_USERPROVISIONING_UPDATEGROUP } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/UpdateGroup/action";
import { UPDATE_USER as ACTION_MONDOO_SCIM_USERPROVISIONING_UPDATEUSER } from "~/lib/iam/actions/mondoo/scim/UserProvisioning/UpdateUser/action";

export const allowedActions = [
  ACTION_MONDOO_SCIM_USERPROVISIONING_CREATEGROUP,
  ACTION_MONDOO_SCIM_USERPROVISIONING_CREATEUSER,
  ACTION_MONDOO_SCIM_USERPROVISIONING_DELETEGROUP,
  ACTION_MONDOO_SCIM_USERPROVISIONING_DELETEUSER,
  ACTION_MONDOO_SCIM_USERPROVISIONING_GETGROUP,
  ACTION_MONDOO_SCIM_USERPROVISIONING_GETUSER,
  ACTION_MONDOO_SCIM_USERPROVISIONING_LISTGROUPS,
  ACTION_MONDOO_SCIM_USERPROVISIONING_LISTUSERS,
  ACTION_MONDOO_SCIM_USERPROVISIONING_UPDATEGROUP,
  ACTION_MONDOO_SCIM_USERPROVISIONING_UPDATEUSER,
] as const;
